/**
 * Leadership page functionality.
 */
jQuery(function($){
    var wait = 250;
    function setHeight() {
        $('.pica8-team-member__body').each(function(){
            $(this).height($('> .wpb_wrapper', this).outerHeight(true));
        });
    }
    $(window).resize(_.throttle(setHeight, wait));
    setHeight();
    $('.pica8-team-member .site-btn').click(function(e){
        e.preventDefault();
        $(this).closest('.pica8-team-member').toggleClass('collapsed');
    });
});
